import type {
  Node2dExtracted,
  Edge2dExtracted,
  EdgeMap,
  Edge2dComputed,
} from ".."
import { doSegmentsIntersect } from "../../2d"
import { overlaps } from "../../utils"

export const findIntersectingEdges = (
  pointsByX: Node2dExtracted[],
  edges: EdgeMap,
): Set<Edge2dExtracted> => {
  let observedEdges: Edge2dExtracted[] = []
  const intersectingEdges: Set<Edge2dExtracted> = new Set()
  for (const point of pointsByX) {
    for (const edgeId of point.edgeIds) {
      const edge1 = edges.get(edgeId)
      if (!edge1) throw new Error(`${edgeId} not found`)
      if (observedEdges.includes(edge1)) {
        observedEdges = observedEdges.filter((edge) => edge !== edge1)
      } else {
        for (const edge2 of observedEdges) {
          const doHaveCommonPoint = Boolean(
            overlaps(
              [edge1.node1id, edge1.node2id],
              [edge2.node1id, edge2.node2id],
            ),
          )
          // a common point means they can't intersect
          if (doHaveCommonPoint) continue
          const edgesDoIntersect = doSegmentsIntersect(edge1, edge2)
          if (edgesDoIntersect) {
            intersectingEdges.add(edge1)
            intersectingEdges.add(edge2)
          }
        }
        observedEdges.push(edge1)
      }
    }
  }

  return intersectingEdges
}
